import { type Dispatch, type SetStateAction } from 'react'

export enum UpdateEmailStepEnum {
  CHANGE = 'CHANGE_EMAIL',
  VERIFY = 'VERIFY_EMAIL',
  CONFIRM = 'CONFIRM_EMAIL',
  ERROR = 'ERROR',
}

export enum UpdateEmailField {
  EMAIL = 'EMAIL',
  OTP_CODE = 'OTP_CODE',
}

export interface UpdateEmailStep {
  ctaOnClick: () => void
  isLoading: boolean
  resendCode: () => void
  closeModal: () => void
}

export interface UpdateEmailProps {
  closeModal: () => void
  setModalTitle: Dispatch<SetStateAction<string>>
}

export interface UpdateEmailForm {
  [UpdateEmailField.EMAIL]: string
  [UpdateEmailField.OTP_CODE]: string
}
